import { makeStyles, TextField } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import Chord from '@tonaljs/chord'
import React, { memo, useCallback, useContext, useEffect, useRef, useState } from 'react'
import { allChords, allNotes, getDegreeNotation } from '../util/TonalUtils'
import ChordEl from './ChordEl'
import { EditorActionType } from './editorStore/backingTrackGeneratorEditorActions'
import BackingTrackGeneratorEditorContext from './editorStore/BackingTrackGeneratorEditorContext'
// import BackingTrackGeneratorSectionsContext from './sectionsStore/BackingTrackGeneratorSectionsContext'
// import { SectionsActionType } from './sectionsStore/backingTrackGeneratorSectionsActions'
import isEqual from 'react-fast-compare'
import { deepDiffMapper } from '../util/deepDiffMapper'
import { isIndexInRanges } from '../util/utils'
import { DRAG_TIMEOUT } from '../util/constants'


const useStyles = makeStyles((theme) => ({
	input: {
		backgroundColor: 'transparent',
		// width: 36,
		color: 'inherit',
		transform: 'translateY(1px)',
		border: 'none',
		fontSize: 17,
		textAlign: 'center',
		'&:focus': {
			border: '1px solid #ffffff4a',
			borderRadius: 4,
			textAlign: 'left',
		},
		'&:focus-visible': {
			outline: 'none',
		}
	},
	span: {
		margin: '0 -2px',
		padding: '0 12px',// TODO : remove padding if card too small
		width: '100%',
		minHeight: 44,
		// maxWidth: 46,
		// minWidth: 46,
		// maxHeight: 53,
		// minHeight: 53,
		cursor: 'pointer',
		display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
		fontSize: 20,
		// userSelect: 'none',
	}
}))

const getNote = (value: string) => {
	let note = value.substr(0, 3)

	while(note.length > 0) {
		if (allNotes.map(n => n.toUpperCase()).includes(note.toUpperCase())) {
			return note
		}
		note = note.slice(0, note.length - 1)
	}

	// if (((note.length === 3 && note[2] === note[1]) || note.length === 2) && note[1] === '#' || note[1] === 'b' ||
	// 	notes.includes(note)) {// note is already a valid note (Cb, C##, Dbb)
	// }

	return null
}

// console.log({ note: getNote('C'), note2: getNote('Cqskdn'), note3: getNote('C#qsd'), note4: getNote('Cbbqsd') })


const getAllMatchingChords = (value: string) => {

	const note = getNote(value)
	if (!note) return []// Maybe add only chords here with every possible roots (maybe filter on the current scale ?)

	const rest = value.substr(note.length)

	// console.log({ note, rest })
	

	// if rest then note is exact (C7 can't match Cb7)
	const validNotes = rest.length > 0 ? [note] : allNotes.filter(n => n.substr(0, note.length).toLowerCase() === note.toLowerCase())// C might be C# or Cbb

	return validNotes.flatMap(note => allChords.flatMap(chord => chord.aliases.filter(alias => alias.includes(rest)).map(alias => note + alias)))
}


const EditorChordCardInputContent = memo((props: {
	chord: any,
	onChange: (chord: any) => void,
	isEdit: boolean,
	isSelected: boolean,
	isDrag: boolean,
	onTabPressed: () => void,
	onBlur: () => void,
	onFocus: () => void,
	chordIndex: number,
}) => {

	const {
		chord,
		onChange,
		isEdit,
		isSelected,
		isDrag,
		onTabPressed,
		onBlur,
		onFocus,
		chordIndex,
	} = props

	const [edit, setEdit] = useState(false)

	const [value, setValue] = useState(chord === '-' ? '𝄽' : chord === '_' ? '' : chord.currentName)

	const [options, setOptions] = useState<any[]>([])

	const inputRef = useRef<any>(null)

	const classes = useStyles()

	const renderCount = useRef(0)

	useEffect(() => setValue(chord === '-' ? '𝄽' : chord === '_' ? '' : chord.currentName), [chord])

	useEffect(() => {// Use for tab navigation
		// console.log({ isEdit })

		if (isEdit) {
			setEdit(true)
			setTimeout(() => inputRef.current.focus(), 0)
		}
	}, [isEdit])

	// console.log({ allChords, allNotes, options })
	
	const handleInputChange = (value: any) => {// TODO : order matchingChords
		const options = getAllMatchingChords(value)
		options.sort((o1: any, o2 : any) => o1.length < o2.length ? -1 : o1.length > o2.length ? 1 : 0)
		// console.log({ options })
		setOptions(options)
	}

	const handleClick = () => {
		console.log('chordCardInput handleClick', { isDrag })
		
		if (!isSelected || isDrag) return
		// console.log({ inputRef: inputRef.current.focus })

		setEdit(true)
		setTimeout(() => inputRef?.current.focus(), 0)// Or inputRef.current is null
	}

	const handleBlur = (e: any) => {
		setEdit(false)

		// if (e.target.value === '-' || e.target.value === '_') {
		// 	setValue(e.target.value)
		// 	onChange(e.target.value)
		// 	return
		// }

		// if (e.target.value === '') {
		// 	setValue('')
		// 	onChange('_')
		// 	return
		// }

		console.log({ e })

		handleChange(e.target.value)
		// if (e._reactName !== 'onBlur')
			onBlur()
	}

	const handleKeyPress = (e: any) => {

		console.log({ e })

		if (e.keyCode === 27) {
			inputRef.current.blur()
			e.stopPropagation()
			e.preventDefault()
		}
		
		if ((/*e.keyCode === 13 || */e.keyCode === 9)) {// enter, tab
			// DONE : if tab then validate selected option
			// if (options.map(option => option.toLowerCase()).includes(e.target.value.toLowerCase()) && e.target.value !== value && !Chord.get(e.target.value).empty) {
			// 	console.log('')
			// 	console.log({ tabPressed: e.target.value })

			// 	// handleChange(e.target.value)
			// 	setTimeout(() => inputRef.current.blur(), 0)
			// }
			// console.log({ handleKeyPress: e })
			
			const enterPressEvent = new KeyboardEvent('keydown', {
				code: 'Enter',
				key: 'Enter',
				charCode: 13,
				keyCode: 13,
				view: window,
				bubbles: true,
				// detail: 1,
			})

			e.target.dispatchEvent(enterPressEvent)

			onTabPressed()
			inputRef.current.blur()
			e.stopPropagation()
			e.preventDefault()
		}
		// else if (e.keyCode === 13 || e.keyCode === 27) {// enter, escape
		// 	setTimeout(() => inputRef.current.blur(), 0)
		// }

		// Needed cause enter with empty value didn't blur
		if (e.keyCode === 13 && e.target.value === '') {// enter
			inputRef.current.blur()
			e.stopPropagation()
			e.preventDefault()
		}
	}

	const handleChange = (value: string) => {

		console.log({ handleChange: value })
		
		const chord2 = Chord.get(value)

		// console.log({ handleChangeNewChord: chord })

		if (!chord2.empty) {
			setValue(value)
			onChange({
				...chord,
				currentName: value,
				...chord2
			})
		}
	}

	// useEffect(() => setValue(chord === '-' ? '𝄽' : chord === '_' ? '' : chord.symbol), [chord])

	return (
		<React.Fragment>

			{/* {chordIndex} */}
			{/* {renderCount.current++ + ' times'} */}

			{!edit && chord === '-' ? (
				<span className={classes.span} style={{ opacity: 0.6 }} onClick={handleClick}>𝄽</span>
			) : !edit && chord === '_' ? (
				<span className={classes.span} onClick={handleClick}></span>
			) : !edit ? (
				<ChordEl
					chord={chord}
					// className={classes.span}
					onClick={handleClick}
					isDegree
				/>
			) : undefined}

			<span
				className={classes.span}
				style={{ display: edit ? 'flex' : 'none', flexGrow: 1 }}
			>
				<Autocomplete
					style={{ marginLeft: 3, marginTop: -1, fontSize: 20, maxWidth: 100, width: '100%' }}
					className='editor-card-input'
					autoHighlight
					clearOnBlur
					
					value={value}
					options={options}
					renderInput={(params) => <TextField {...params} inputRef={inputRef} onKeyDown={handleKeyPress} margin='normal' />}
					onBlur={handleBlur}
					onInputChange={(e: any, value: string) => handleInputChange(value)}
					onChange={(e, option) => option !== null && setTimeout(() => inputRef.current.blur(), 0)}
					onFocus={(e: any) => { onFocus(); e.target.select() }}
				/>
			</span>

		</React.Fragment>
	)
}, (o1: any, o2: any) => {

	// if (!isEqual(o1, o2)) {
	// 	const diff = deepDiffMapper.map(o1, o2)
	// 	console.log({ o1, o2, diff })
	// }

	return isEqual(o1, o2)
})

// TODO : When making it work, pass less props to CardInput, this will prevent rerender

const EditorChordCardInput = (props: {
	chordIndex: number,
	isEdit: boolean,
	isSelected: boolean,
}) => {

	const {
		chordIndex,
		isEdit,
		isSelected
	} = props
	
	// const [sections, dispatchSections] = useContext(BackingTrackGeneratorSectionsContext)

	const [editor, dispatchEditor] = useContext(BackingTrackGeneratorEditorContext)
	
	// console.log({ editIndex })
	// console.log({ EditorChordCardInput: sections })

	const chord = (editor.fakeChords || editor.chords)[chordIndex]

	const isDrag = isIndexInRanges(chordIndex, editor.state.chordSelectedRanges) && editor.fakeChords !== undefined

	const [isDrag2, setIsDrag2] = useState(isDrag)

	// Use to prevent input select after drag (mouseUp being fire before mouseClick fakeChords will already been undefined)
	// FIXME : This is a workaround
	useEffect(() => { setTimeout(() => setIsDrag2(isDrag), DRAG_TIMEOUT) }, [isDrag])

	const handleTabPressed = useCallback(() => {
		// console.log({ handleTabPressed: globalIndex })
		setTimeout(() => dispatchEditor({
			type: EditorActionType.ChordTabPressed,
			payload: {
				index: chordIndex
			}
		}), 0)
	}, [])
	// }, [chordIndex])

	const handleBlur = useCallback(() => {
		// console.log({ handleBlur: true })
		dispatchEditor({
			type: EditorActionType.ChordBlur
		})
	}, [])

	const handleFocus = useCallback(() => {
		console.log({ handleFocus: editor.fakeChords })
		if (editor.fakeChords !== undefined) return

		dispatchEditor({
			type: EditorActionType.ChordFocus,
			payload: {
				index: chordIndex
			}
		})
	}, [editor.fakeChords])

	const handleChange = useCallback((chord: any) => {
		dispatchEditor({
			type: EditorActionType.ChordChange,
			payload: {
				chord: {
					...chord,
					degreeName: getDegreeNotation(chord, editor.config.scale)
				}
			}
		})
	}, [editor.config.scale])

	return (
		<EditorChordCardInputContent
			chord={chord}
			onChange={handleChange}
			isEdit={isEdit}
			onTabPressed={handleTabPressed}
			onBlur={handleBlur}
			onFocus={handleFocus}
			isSelected={isSelected}
			isDrag={isDrag2}
			chordIndex={chordIndex}
		/>
	)
}

export default EditorChordCardInput
